import {
  createInteractiveFormSession as publicCreateInteractiveFormSession,
  createInteractiveFormSessionStreamed as publicCreateInteractiveFormSessionStreamed,
  sendUserMessage as publicSendUserMessage,
  sendUserMessageStreamed as publicSendUserMessageStreamed,
  generateFormSummary as publicGenerateFormSummary,
} from './forms-ai-v1-interactive-form-session-interactive-form-sessions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onInteractiveFormSessionCreated as publicOnInteractiveFormSessionCreated } from './forms-ai-v1-interactive-form-session-interactive-form-sessions.public.js';

export const createInteractiveFormSession: MaybeContext<
  BuildRESTFunction<typeof publicCreateInteractiveFormSession> &
    typeof publicCreateInteractiveFormSession
> = /*#__PURE__*/ createRESTModule(publicCreateInteractiveFormSession);
export const createInteractiveFormSessionStreamed: MaybeContext<
  BuildRESTFunction<typeof publicCreateInteractiveFormSessionStreamed> &
    typeof publicCreateInteractiveFormSessionStreamed
> = /*#__PURE__*/ createRESTModule(publicCreateInteractiveFormSessionStreamed);
export const sendUserMessage: MaybeContext<
  BuildRESTFunction<typeof publicSendUserMessage> & typeof publicSendUserMessage
> = /*#__PURE__*/ createRESTModule(publicSendUserMessage);
export const sendUserMessageStreamed: MaybeContext<
  BuildRESTFunction<typeof publicSendUserMessageStreamed> &
    typeof publicSendUserMessageStreamed
> = /*#__PURE__*/ createRESTModule(publicSendUserMessageStreamed);
export const generateFormSummary: MaybeContext<
  BuildRESTFunction<typeof publicGenerateFormSummary> &
    typeof publicGenerateFormSummary
> = /*#__PURE__*/ createRESTModule(publicGenerateFormSummary);
/**
 * Triggered when an interactive form session is created.
 */
export const onInteractiveFormSessionCreated: BuildEventDefinition<
  typeof publicOnInteractiveFormSessionCreated
> &
  typeof publicOnInteractiveFormSessionCreated = createEventModule(
  publicOnInteractiveFormSessionCreated
);

export {
  StringTypeFormatEnumFormat,
  DayOfWeek,
  ValidationFormat,
  ProductType,
  PriceType,
  FieldType,
  FormatEnumFormat,
  StringComponentType,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  LinkTarget,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  CardStylesAlignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  LayoutDataImagePosition,
  Origin,
  LayoutDataBackgroundType,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  ImagePosition,
  Alignment,
  ImageFit,
  NumberOfColumns,
  FirstDayOfWeek,
  NumberComponentType,
  BooleanComponentType,
  ItemType,
  PropertiesTypeEnum,
  ArrayComponentType,
  WixFileComponentType,
  UploadFileFormat,
  PaymentComponentType,
  ComponentType,
  DefaultCountryConfigType,
  ObjectArrayComponentType,
  SchedulingComponentType,
  Format,
  MeetingType,
  StaffStrategySelection,
  InputType,
  EmailInfoTag,
  PhoneInfoTag,
  Tag,
  ConfirmationLevel,
  SubscriptionChannel,
  ContactField,
  DisplayFieldType,
  OverrideEntityType,
  Kind,
  FormFieldContactInfoEmailInfoTag,
  FormFieldContactInfoPhoneInfoTag,
  AddressInfoTag,
  OptInLevel,
  FormFieldContactInfoContactField,
  SpamFilterProtectionLevel,
  RequiredIndicator,
  RequiredIndicatorPlacement,
  Target,
  SubmitSuccessAction,
  ChangeableProperty,
  OverrideEntityTypeEnumOverrideEntityType,
  Operator,
  ResultsDisplay,
  ContactAutofill,
  SubmissionAccess,
  ChunkType,
  Style,
  Type,
  Role,
  WebhookIdentityType,
} from './forms-ai-v1-interactive-form-session-interactive-form-sessions.universal.js';
export {
  InteractiveFormSession,
  Form,
  FormField,
  FormFieldStringType,
  FormFieldStringTypeFormatOptionsOneOf,
  StringErrorMessages,
  DateTimeAdvancedConstraints,
  Availability,
  DateRange,
  StringTypeDateTimeConstraints,
  StringTypePhoneConstraints,
  StringTypeValidationMessages,
  FormFieldNumberType,
  NumberErrorMessages,
  IntegerType,
  FormFieldBooleanType,
  BooleanErrorMessages,
  FormFieldArrayType,
  FormFieldObjectType,
  ObjectTypePropertiesType,
  ObjectTypePropertiesTypePropertiesTypeOneOf,
  ObjectErrorMessages,
  ArrayTypeArrayItems,
  ArrayTypeArrayItemsItemsOneOf,
  ArrayErrorMessages,
  PredefinedValidation,
  PredefinedValidationFormatOptionsOneOf,
  PaymentType,
  QuantityLimit,
  FixedPriceOptions,
  DynamicPriceOptions,
  Product,
  ProductPriceOptionsOneOf,
  MultilineAddressValidation,
  FieldOverrides,
  FieldsOverrides,
  ObjectArrayType,
  NestedFormFieldOverrides,
  Validation,
  ValidationValidationOneOf,
  DataExtensionsDetails,
  NestedFormOverrides,
  Field,
  FieldFieldTypeOptionsOneOf,
  InputField,
  InputFieldInputTypeOptionsOneOf,
  StringCorrectAnswersList,
  StringType,
  StringTypeFormatOptionsOneOf,
  DateTimeConstraints,
  PhoneConstraints,
  ValidationMessages,
  StringQuizFieldSettings,
  TextInput,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  PollOption,
  Settings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackgroundImage,
  Banner,
  LayoutDataBackground,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  MediaItem,
  MediaItemMediaOneOf,
  MediaSettings,
  RadioGroup,
  RadioGroupOption,
  CustomOption,
  Dropdown,
  DropdownOption,
  DateTimeInput,
  PhoneInput,
  DateInput,
  TimeInput,
  DatePicker,
  ServicesDropdown,
  ServiceOption,
  Password,
  NumberCorrectAnswersList,
  NumberType,
  NumberQuizFieldSettings,
  NumberInput,
  RatingInput,
  BooleanType,
  Checkbox,
  CorrectAnswersList,
  ArrayType,
  ObjectType,
  PropertiesType,
  PropertiesTypePropertiesTypeOptionsOneOf,
  ArrayItems,
  ArrayItemsItemTypeOptionsOneOf,
  QuizFieldSettings,
  CheckboxGroup,
  CheckboxGroupOption,
  ComponentsTags,
  TagsOption,
  ServicesCheckboxGroup,
  FileType,
  FileUpload,
  Signature,
  ProductCheckboxGroup,
  ProductCheckboxGroupOption,
  DonationInput,
  DonationInputOption,
  PaymentInput,
  FixedPayment,
  MultilineAddress,
  AddressLine2,
  DefaultCountryConfig,
  DefaultCountryConfigOptionsOneOf,
  FieldsSettings,
  Repeater,
  FormLayout,
  BreakPoint,
  ItemLayout,
  ItemLayoutItemOneOf,
  Group,
  Margin,
  Section,
  Appointment,
  AppointmentFormatInfoOneOf,
  Location,
  LocationLocationInfoOneOf,
  InPersonOptions,
  VideoConferenceOptions,
  PhoneOptions,
  FormFieldContactInfo,
  FormFieldContactInfoAdditionalInfoOneOf,
  EmailInfo,
  PhoneInfo,
  AddressInfo,
  CustomFieldInfo,
  SubscriptionInfo,
  _String,
  _StringComponentTypeOptionsOneOf,
  _Number,
  _NumberComponentTypeOptionsOneOf,
  _Boolean,
  _BooleanComponentTypeOptionsOneOf,
  _Array,
  _ArrayComponentTypeOptionsOneOf,
  _Object,
  WixFile,
  WixFileComponentTypeOptionsOneOf,
  Payment,
  PaymentComponentTypeOptionsOneOf,
  Scheduling,
  SchedulingComponentTypeOptionsOneOf,
  Address,
  AddressComponentTypeOptionsOneOf,
  ObjectArray,
  ObjectArrayComponentTypeOptionsOneOf,
  DisplayField,
  DisplayFieldDisplayFieldTypeOptionsOneOf,
  RichContentOptions,
  PageNavigationOptions,
  Step,
  FormRule,
  FormOverride,
  FormProperties,
  PostSubmissionTriggers,
  UpsertContact,
  V4FormFieldContactInfo,
  V4FormFieldContactInfoAdditionalInfoOneOf,
  FormFieldContactInfoEmailInfo,
  FormFieldContactInfoPhoneInfo,
  FormFieldContactInfoAddressInfo,
  FormFieldContactInfoCustomFieldInfo,
  FormFieldContactInfoSubscriptionInfo,
  ExtendedFields,
  NestedForm,
  LimitationRule,
  RequiredIndicatorProperties,
  SubmitSettings,
  SubmitSettingsSubmitSuccessActionOptionsOneOf,
  ThankYouMessageOptions,
  RedirectOptions,
  PopupOptions,
  FieldGroup,
  Rule,
  RequiredOptions,
  HiddenOptions,
  AllowedValuesOptions,
  FieldOverride,
  FieldOverridePropertyTypeOptionsOneOf,
  ConditionNode,
  ConditionNodeNodeOneOf,
  AndCondition,
  OrCondition,
  Condition,
  RuleFormOverride,
  RuleFormOverrideEntityTypeOptionsOneOf,
  Tags,
  TagList,
  QuizSettings,
  QuizSettingsPassingCriteriaOneOf,
  QuizSettingsResultsDisplayOptionsOneOf,
  PassFailMessages,
  CreateInteractiveFormSessionRequest,
  ClientTime,
  CreateInteractiveFormSessionResponse,
  InteractiveFormSessionResponseChunk,
  InteractiveFormSessionResponseChunkOfOneOf,
  TextDetails,
  TextDataDetails,
  MultiSelectInputDetails,
  Option,
  CustomValue,
  NumberInputDetails,
  NumberRangeLimit,
  NumberRangeLimitEndOneOf,
  SeparatorDetails,
  SingleSelectInputDetails,
  ErrorDetails,
  SubmissionDetails,
  ImportantTextDetails,
  DebugDetails,
  EndOfResponseDetails,
  FileUploadDetails,
  SignatureDetails,
  MeaningfulInput,
  CreateInteractiveFormSessionStreamedRequest,
  CreateInteractiveFormSessionStreamedResponse,
  SendUserMessageRequest,
  SendUserMessageResponse,
  SendUserMessageStreamedRequest,
  SendUserMessageStreamedResponse,
  ConverseRequest,
  ConverseRequestRequestOneOf,
  GetStateRequest,
  CallToolsRequest,
  Call,
  RelayAssistantMessageRequest,
  UsageRequest,
  Usage,
  ConverseResponse,
  ConverseResponseResponseOneOf,
  GetStateResponse,
  Tool,
  ContextMessage,
  ContextMessageOptionsOneOf,
  UserOptions,
  AssistantOptions,
  FunctionCallOptions,
  FunctionCallOutputOptions,
  DeveloperOptions,
  CallToolsResponse,
  Response,
  AcknowledgmentResponse,
  OutputInteractiveFormSessionStreamedRequest,
  OutputInteractiveFormSessionStreamedResponse,
  ReportConversationRequest,
  ReportConversationResponse,
  GenerateFormSummaryRequest,
  GenerateFormSummaryResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  InteractiveFormSessionCreatedEnvelope,
  CreateInteractiveFormSessionOptions,
  CreateInteractiveFormSessionStreamedOptions,
  SendUserMessageOptions,
  SendUserMessageStreamedOptions,
} from './forms-ai-v1-interactive-form-session-interactive-form-sessions.universal.js';
export {
  StringTypeFormatEnumFormatWithLiterals,
  DayOfWeekWithLiterals,
  ValidationFormatWithLiterals,
  ProductTypeWithLiterals,
  PriceTypeWithLiterals,
  FieldTypeWithLiterals,
  FormatEnumFormatWithLiterals,
  StringComponentTypeWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  LinkTargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  CardStylesAlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  LayoutDataImagePositionWithLiterals,
  OriginWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  ImagePositionWithLiterals,
  AlignmentWithLiterals,
  ImageFitWithLiterals,
  NumberOfColumnsWithLiterals,
  FirstDayOfWeekWithLiterals,
  NumberComponentTypeWithLiterals,
  BooleanComponentTypeWithLiterals,
  ItemTypeWithLiterals,
  PropertiesTypeEnumWithLiterals,
  ArrayComponentTypeWithLiterals,
  WixFileComponentTypeWithLiterals,
  UploadFileFormatWithLiterals,
  PaymentComponentTypeWithLiterals,
  ComponentTypeWithLiterals,
  DefaultCountryConfigTypeWithLiterals,
  ObjectArrayComponentTypeWithLiterals,
  SchedulingComponentTypeWithLiterals,
  FormatWithLiterals,
  MeetingTypeWithLiterals,
  StaffStrategySelectionWithLiterals,
  InputTypeWithLiterals,
  EmailInfoTagWithLiterals,
  PhoneInfoTagWithLiterals,
  TagWithLiterals,
  ConfirmationLevelWithLiterals,
  SubscriptionChannelWithLiterals,
  ContactFieldWithLiterals,
  DisplayFieldTypeWithLiterals,
  OverrideEntityTypeWithLiterals,
  KindWithLiterals,
  FormFieldContactInfoEmailInfoTagWithLiterals,
  FormFieldContactInfoPhoneInfoTagWithLiterals,
  AddressInfoTagWithLiterals,
  OptInLevelWithLiterals,
  FormFieldContactInfoContactFieldWithLiterals,
  SpamFilterProtectionLevelWithLiterals,
  RequiredIndicatorWithLiterals,
  RequiredIndicatorPlacementWithLiterals,
  TargetWithLiterals,
  SubmitSuccessActionWithLiterals,
  ChangeablePropertyWithLiterals,
  OverrideEntityTypeEnumOverrideEntityTypeWithLiterals,
  OperatorWithLiterals,
  ResultsDisplayWithLiterals,
  ContactAutofillWithLiterals,
  SubmissionAccessWithLiterals,
  ChunkTypeWithLiterals,
  StyleWithLiterals,
  TypeWithLiterals,
  RoleWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SendUserMessageApplicationErrors,
  SendUserMessageStreamedApplicationErrors,
  GenerateFormSummaryApplicationErrors,
} from './forms-ai-v1-interactive-form-session-interactive-form-sessions.universal.js';
